import { jsxs as r, jsx as c } from "react/jsx-runtime";
import n from "react";
import { Indicator as q } from "../Indicator/Indicator.js";
import { clsx as H } from "../../utils/clsx.js";
import { getValue as J } from "../../utils/getValue.js";
import { useDynamicRef as i } from "../../utils/hooks.js";
import '../../assets/Input.css';const O = "_root_gmtev_1", P = "_input_gmtev_1", Q = "_small_gmtev_8", U = "_large_gmtev_12", Y = "_decorator_gmtev_60", Z = "_error_gmtev_68", $ = "_disabled_gmtev_72", ee = "_description_gmtev_106", e = {
  root: O,
  input: P,
  small: Q,
  large: U,
  "full-width": "_full-width_gmtev_57",
  decorator: Y,
  error: Z,
  disabled: $,
  description: ee,
  "backdrop-blur": "_backdrop-blur_gmtev_111"
}, ce = n.forwardRef(function(t, g) {
  const {
    label: d,
    value: v,
    onChange: N,
    onSubmit: C,
    onKeyDown: k = () => !1,
    pattern: a,
    tabIndex: w,
    error: y = !1,
    fullWidth: I = !1,
    showLoader: u = !1,
    noSpellCheck: R = !1,
    autofocus: x = !1,
    disabled: m = !1,
    className: E = "",
    placeholder: D = "",
    inputClassName: S = "",
    inputRef: F,
    description: _ = "",
    type: K = "text",
    size: A = "normal",
    decorator: l,
    backdropBlur: j = !1
  } = t, G = t.type === "number" && (t.min ?? Number.MIN_SAFE_INTEGER) || void 0, M = t.type === "number" && (t.max ?? Number.MAX_SAFE_INTEGER) || void 0, f = n.useId(), p = i(N), T = i(k), b = i(C), V = n.useCallback(
    (o) => {
      const {
        value: s
      } = o.target;
      if (a) {
        a.test(s) && p.current(s);
        return;
      }
      return p.current(s);
    },
    [a]
  ), z = n.useCallback((o) => {
    T.current(o) || b.current && o.key === "Enter" && b.current();
  }, []), B = u || l ? /* @__PURE__ */ r("div", { className: e.decorator, children: [
    !!u && /* @__PURE__ */ c(q, {}),
    !!l && J(l)
  ] }) : null, h = /* @__PURE__ */ r("div", { className: e.input, children: [
    /* @__PURE__ */ c(
      "input",
      {
        id: f,
        ref: F,
        type: K,
        tabIndex: w,
        autoFocus: x,
        className: S,
        value: v,
        placeholder: D,
        disabled: m,
        onChange: V,
        onKeyDown: z,
        spellCheck: !R,
        min: G,
        max: M
      }
    ),
    B
  ] }), L = _ ? /* @__PURE__ */ c("div", { className: e.description, children: _ }) : null, W = d ? /* @__PURE__ */ r("label", { htmlFor: f, children: [
    d,
    h
  ] }) : h, X = H(e.root, e[A], E, {
    [e["full-width"]]: I,
    [e.error]: y,
    [e.disabled]: m,
    [e["backdrop-blur"]]: j
  });
  return /* @__PURE__ */ r("div", { ref: g, className: X, children: [
    W,
    L
  ] });
});
export {
  ce as Input
};
